var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgPromoFlag = function SvgSvgPromoFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.385 14.173c0-.4.156-.778.44-1.06l11.63-11.63a3.726 3.726 0 0 1 2.65-1.099h6.259a2.252 2.252 0 0 1 2.25 2.25v6.258a3.725 3.725 0 0 1-1.1 2.651l-11.63 11.63c-.21.21-.474.352-.766.41-.392.08-.792 0-1.126-.223a1.49 1.49 0 0 1-.64-.953l-1.126-5.636-5.636-1.127a1.5 1.5 0 0 1-1.205-1.47ZM22.114 2.634a.75.75 0 0 0-.75-.75h-6.258c-.601 0-1.166.234-1.59.66l-11.63 11.63 6.125 1.224c.298.06.529.29.588.59l1.225 6.125 11.63-11.63c.425-.425.659-.99.659-1.59V2.633Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.364 6.384a2.252 2.252 0 0 1 2.25-2.25 2.252 2.252 0 0 1 2.25 2.25 2.252 2.252 0 0 1-2.25 2.25 2.252 2.252 0 0 1-2.25-2.25Zm3 0a.75.75 0 1 0-1.5 0 .75.75 0 0 0 1.5 0Z",
    fill: "currentColor"
  })));
};
export default SvgSvgPromoFlag;